import type { TinyEmitter } from "@expert/event-bus";
import type { WebSocketLike } from "react-use-websocket/dist/lib/types";
import { create } from "zustand";
import type { ExpertUniversityEvents } from "./src";

export interface ExpertUniversityStore {
    profileId?: string | undefined;
    eventBus?: TinyEmitter<ExpertUniversityEvents> | undefined;
    audioElements?: HTMLAudioElement[];
    isBotPlaying?: boolean;
    setIsBotPlaying: (isPlaying: boolean) => void;
    sendMessage?: (msg: ArrayBuffer) => void;
    getWebsocket?: () => WebSocketLike | null;
    setProfileId: (profileId: string | undefined) => void;
    setWSFunctions: (send: (msg: ArrayBuffer) => void, getWs: () => WebSocketLike | null) => void;
    resetEvents: () => void;
    setEventBus: (eventBus: TinyEmitter | undefined) => void;
}

export const useExpertUniversityStore = create<ExpertUniversityStore>((set, _get) => ({
    setIsBotPlaying: (isPlaying) => set({ isBotPlaying: isPlaying }),
    setProfileId: (profileId) => set({ profileId }),
    setEventBus: (eventBus) => set({ eventBus }),
    audioElements: [],
    setWSFunctions: (send, getWs) => set({ sendMessage: send, getWebsocket: getWs }),
    resetEvents: () =>
        set({
            profileId: undefined,
            audioElements: [],
            isBotPlaying: false,
        }),
}));
